import React from 'react';
import clsx from 'clsx';
import './newstyle.css';
import { ReactComponent as SearchIcon } from '../../assets/images/TicketImages/search.svg';
import { ReactComponent as PeopleSearchIconAsset } from '../../assets/images/People/people-search-16.svg';


function SearchInput(props) {
  const {
    placeholder = 'Search...',
    title = 'Search',
    name = 'search',
    id = 'search',
    error,
    onChange = () => { },
    value,
    className,
    onKeyPress,
    onFocus,
    onKeyDown,
    onMouseDown,
    onBlur,
    ref,
    noTitle = false,
    style,
    inputStyle,
    iconStyle,
    iconPosition = 'right',
    iconGap = 8,
    iconVariant = "default",
  } = props;

  const IconComponent = iconVariant === "people" ? PeopleSearchIconAsset : SearchIcon;
  const iconDisplaySize = iconVariant === "people" ? 16 : undefined;
  const iconLeftOffset = iconVariant === "people" ? 12 : 16;

  const iconBaseStyle =
    iconPosition === 'left'
      ? { left: iconLeftOffset, right: 'auto' }
      : { right: 17, left: 'auto' };

  const inputPadding =
    iconPosition === 'left'
      ? `13px 16px 13px ${iconLeftOffset + (iconDisplaySize || 16) + iconGap}px`
      : '13px 35px 13px 16px';

  return (
    <div className={`input-main-div-search ${className}`}>
      {!noTitle &&
        <div className="Input-headingcontainer01-search">
          <props className="input-div">
            {title}
          </props>
        </div>
      }

      <div
        className="search-input-container-search"
        style={{ ...style, overflow: iconVariant === "people" ? "visible" : undefined }}
      >
        <IconComponent
          className="search-icon-search"
          style={{
            ...iconBaseStyle,
            ...iconStyle,
            overflow: "visible",
            ...(iconDisplaySize
              ? { width: iconDisplaySize, height: iconDisplaySize, flexShrink: 0 }
              : {}),
          }}
        />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          name={name}
          onKeyDown={onKeyDown}
          onMouseDown={onMouseDown}
          id={id}
          className={clsx(className, 'input-new-search')}
          style={{ padding: inputPadding, ...inputStyle }}
          onChange={(e) => onChange(e)}
          onKeyPress={onKeyPress}
          onFocus={onFocus}
          ref={ref}
        />
      </div>
      {error && <p className="InputErrorMsg-search">{error}</p>}
    </div>
  );
}

export default SearchInput;
